import { ReparoApi } from '@api';
import type { SalesInsightsContext, SalesInsightsResponse } from '@components/containers/sales/types';

export const fetchSalesInsights = async (
    context: SalesInsightsContext,
): Promise<SalesInsightsResponse> => {
    return ReparoApi<SalesInsightsResponse>({
        method: 'POST',
        url: '/sales/insights',
        body: JSON.stringify(context),
    });
};
